<template>
  <div class="firstLoading">
    <!-- <div class="loading-block">
      <div v-if="loading">加载数据中...</div>
    </div> -->
  </div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      loading:true,
      EnterPaylod:{
        // appId:"",
        // mobile:"",//用户名
        // nonceStr:"",//随机数
        // sign:"",//签名秘钥
        taskNo:"",
          // appId: "1250035846401335297",
          // mobile: "18696208152",
          // nonceStr: "185897670694064",
          // sign: "B8AE75F8F6222B9D541A55F6286943E8",
          // taskNo:"B8AE75F8F6222B9D541A55F6286943E8"
      }
    }
  },
  mounted() {
    this.$toast.loading('数据加载中...')
    const url = new URL(location.href);
    // this.EnterPaylod.appId = url.searchParams.get('appId');
    // this.EnterPaylod.mobile= url.searchParams.get('mobile');
    // this.EnterPaylod.nonceStr= url.searchParams.get('nonceStr');
    // this.EnterPaylod.sign= url.searchParams.get('sign');
    this.EnterPaylod.taskNo= url.searchParams.get('taskNo');
    console.log(url)
    this.postUserMessage()
    // sessionStorage.setItem('user_mobile', mobile)
  },
  methods:{
    postUserMessage(){
      this.$toast.clear() 
      http.post(config.taskDetail,this.EnterPaylod).then(({code,data,message})=>{
        if(code===0){
          this.loading=false;
          if(data.code===200){
            this.$router.push({path:"../taskDetail"})
          }
        }else{
          this.loading=false;
          this.$toast.fail(message)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.firstLoading{
  width: 100%;
  height: 100%;
}
.loading-block{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/entryFile/taskDetailLoading/index.vue